export default __webpack_public_path__ + "static/media/github.a855c397.png";